import styled from 'styled-components'
import { COLORS } from 'consts/colors'

/* Horizontally centered, top-aligned inside the flex-column HistoryContainer:
   the auto inline margins center the (max-300px) column, while `flex: 1` claims
   the free height and `justify-content: flex-start` keeps the content just below
   the tab row rather than adrift in the middle of a tall panel.
   `width: 100%` + border-box keeps it inside the container's content box, so it
   can never widen the panel into a horizontal scroll. */
export const EmptyState = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 16px;
  text-align: center;
  color: ${COLORS.secondarySemiDark};
  width: 100%;
  max-width: 300px;
  margin: 0 auto;
  /* On top of HistoryContainer's own 16px padding-top. */
  padding: 24px 0;
  box-sizing: border-box;
`
